import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

/** Encadré blanc arrondi des pages (tableau, en-tête de fiche, formulaire…) ; as : balise (section pour une région nommée) */
export function Panel({
  as: Tag = 'div',
  className,
  ...props
}: ComponentProps<'div'> & { as?: 'div' | 'section' | 'article' }) {
  return <Tag className={cn('bg-card border border-slate-200 rounded-xl shadow-sm', className)} {...props} />;
}
